import { render, staticRenderFns } from "./SuccessSolid.vue?vue&type=template&id=a902b2c8&"
import script from "./SuccessSolid.vue?vue&type=script&lang=ts&"
export * from "./SuccessSolid.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports